import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportProjectTimeReportByDate_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportProjectTimeReportByDate extends Report<ReportProjectTimeReportByDate_Settings> {

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_PROJECT_TIME_REPORT_BY_DATE
        super(data);

        this.icon         = "isvg-time-task-date"
        // this.description  = "Time entries by task and date."
        this.description  = "Displays reported hours for each task by date within a selected project, providing a detailed timeline of logged work."

        this.settings     = new ReportProjectTimeReportByDate_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportProjectTimeReportByDate {
        return new ReportProjectTimeReportByDate(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportProjectTimeReportByDate_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
